module.exports = __webpack_public_path__ + "img/banner_2025.f686cd00.webp";